/* Dear Nikola site-wide behaviour (Stage 1). Ported from the signed-off mockups (v11.js, bars reworked in v14).
   1. Countdown: every [data-countdown] counts down to midnight in the shopper's own time zone, then starts again.
      data-countdown="blocks" fills child [data-h] [data-m] [data-s] with two-digit numbers.
   2. Offer bar: [data-rotate] holds a list of offers, one on screen at a time, a new one every 5 seconds.
      Arrows and a left or right swipe step through it. It holds still while the mouse is over it, while a keyboard user is
      focused in it and while the tab is hidden. With reduced motion the offers swap instantly and never change on their own.
   The look is in assets/dn-site.css, the wording is in Theme settings > Dear Nikola site. */
/* dn-guard (guards spec G1, 10-08): asset-family self-check.
   Marks that this file ran (window.__dnSiteLoaded), then once the page has loaded checks that every Dear Nikola asset family
   the page's own markup uses is really loaded. A missing stylesheet is loaded late and reported; a missing script is only reported.
   Everything is in try/catch and every outcome is logged as [dn-guard] and marked on <html data-dn-guard="...">, never swallowed.
   Families: dnc- = dn-coll, dnp- = dn-pdp, dnh- = dn-home, site = dn-site (always). Each stylesheet ends with a probe variable --dn-has-<family>. */
window.__dnSiteLoaded = true;
(function () {
  var FAMILIES = [
    { name: 'site', css: 'dn-site.css', probe: '--dn-has-site', always: true },
    { name: 'coll', css: 'dn-coll.css', probe: '--dn-has-coll', cls: 'dnc-', jsOn: 'collection' },
    { name: 'pdp', css: 'dn-pdp.css', probe: '--dn-has-pdp', cls: 'dnp-', jsOn: 'product' },
    { name: 'home', css: 'dn-home.css', probe: '--dn-has-home', cls: 'dnh-', jsOn: 'index' }
  ];
  function mark(tag) {
    try { var de = document.documentElement, cur = de.getAttribute('data-dn-guard'); de.setAttribute('data-dn-guard', cur ? cur + ',' + tag : tag); } catch (e) { /* the console line below is the record */ }
  }
  function heal(f) {
    try {
      /* the versioned URL comes from the layout (a bare assets URL serves an older copy of the file, measured 10-08) */
      var m = document.querySelector('meta[name="dn-asset"][data-family="' + f.name + '"]');
      var url = m ? m.getAttribute('content') : '';
      if (!url) throw new Error('the layout did not provide the ' + f.css + ' address');
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = url; l.setAttribute('data-dn-guard-heal', f.name);
      l.onerror = function () { console.error('[dn-guard] heal FAILED ' + f.name + ': ' + f.css + ' did not load'); mark('healfailed:' + f.name); };
      document.head.appendChild(l);
    } catch (e) {
      console.error('[dn-guard] heal FAILED ' + f.name + ': ' + (e && e.message));
      mark('healfailed:' + f.name);
    }
  }
  function check() {
    try {
      var meta = document.querySelector('meta[name="dn-template"]');
      var tpl = meta ? String(meta.getAttribute('content') || '').split('.')[0] : '';
      var cs = getComputedStyle(document.documentElement);
      FAMILIES.forEach(function (f) {
        var present = f.always || !!document.querySelector('[class*="' + f.cls + '"]');
        if (!present) return;
        if (String(cs.getPropertyValue(f.probe)).trim() !== '1') {
          console.error('[dn-guard] css family ' + f.name + ' is missing on this page (' + f.css + '), loading it late');
          mark('healed:' + f.name);
          heal(f);
        }
        if (f.jsOn && tpl === f.jsOn && !(window.__dnLoaded && window.__dnLoaded[f.name])) {
          console.error('[dn-guard] js family ' + f.name + ' did not run on this ' + tpl + ' page');
          mark('jsmissing:' + f.name);
        }
      });
    } catch (e) {
      console.error('[dn-guard] self-check crashed: ' + (e && e.message));
      mark('crashed');
    }
  }
  if (document.readyState === 'complete') check(); else window.addEventListener('load', check);
})();
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }
  var endsAttr = document.documentElement.getAttribute('data-dn-ends');
  var endsAt = endsAttr ? new Date(endsAttr) : null;
  if (endsAt && isNaN(endsAt)) endsAt = null;
  function left() {
    var now = new Date();
    var to = endsAt || new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
    var t = Math.max(0, Math.floor((to - now) / 1000));
    return { t: t, d: Math.floor(t / 86400), h: Math.floor((t % 86400) / 3600), m: Math.floor((t % 3600) / 60), s: t % 60 };
  }
  function tick() {
    var r = left();
    if (endsAt) {
      document.querySelectorAll('[data-countdown-wrap]').forEach(function (w) { w.hidden = r.t <= 0; });
      if (r.t <= 0) document.querySelectorAll('.dn-sale .dn-until').forEach(function (w) { w.hidden = true; });
    } else {
      r.h += r.d * 24; r.d = 0;
    }
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var f = el.getAttribute('data-countdown');
      if (f === 'blocks') {
        var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
        var d = el.querySelector('[data-d]');
        if (d) { d.textContent = r.d + 'd'; d.hidden = !r.d; if (d.nextElementSibling) d.nextElementSibling.hidden = !r.d; }
        if (h) h.textContent = pad(r.h);
        if (m) m.textContent = pad(r.m);
        if (s) s.textContent = pad(r.s);
      } else if (f === 'words') {
        el.textContent = (r.d ? r.d + 'd ' : '') + r.h + 'h ' + pad(r.m) + 'm ' + pad(r.s) + 's';
      } else {
        el.textContent = pad(r.h) + ' : ' + pad(r.m) + ' : ' + pad(r.s);
      }
    });
  }
  tick();
  setInterval(tick, 1000);

  /* Offer bar: horizontal slide with direction, swipe, 5 seconds, reduced motion. */
  var AUTO_MS = 5000, SLIDE_MS = 450;
  document.querySelectorAll('[data-rotate]').forEach(function (bar) {
    var items = [].slice.call(bar.querySelectorAll('li')), list = bar.querySelector('ul');
    var i = 0, paused = false, settleTimer = null, autoTimer = null;
    if (!items.length) return;
    var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;
    function still() { return !!(mq && mq.matches); }

    /* 10-07 (his note 2): slides differ in lines, so the bar takes the height of the slide on screen, not the tallest one */
    function fit() {
      if (!list || !items[i]) return;
      var h = items[i].offsetHeight;
      if (h) list.style.height = h + 'px';
    }

    items.forEach(function (li, k) { if (li.classList.contains('on')) i = k; });
    items.forEach(function (li, k) { li.classList.toggle('on', k === i); });
    fit();
    window.addEventListener('resize', fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    /* end any slide in progress: only the current offer stays on screen */
    function settle() {
      clearTimeout(settleTimer);
      bar.classList.remove('is-sliding');
      items.forEach(function (li, k) {
        li.classList.remove('pos-l', 'pos-r');
        if (k !== i) li.classList.remove('on');
      });
    }
    /* dir 1 = the new offer comes from the right, -1 = from the left */
    function go(n, dir) {
      n = (n + items.length) % items.length;
      if (n === i) return;
      settle();
      var from = items[i], to = items[n];
      i = n;
      fit();
      if (still()) { from.classList.remove('on'); to.classList.add('on'); return; }
      to.classList.add(dir > 0 ? 'pos-r' : 'pos-l');
      void to.offsetWidth;
      bar.classList.add('is-sliding');
      from.classList.remove('on');
      from.classList.add(dir > 0 ? 'pos-l' : 'pos-r');
      to.classList.remove('pos-l', 'pos-r');
      to.classList.add('on');
      settleTimer = setTimeout(settle, SLIDE_MS + 40);
    }
    function schedule() {
      clearTimeout(autoTimer);
      if (still()) return;
      autoTimer = setTimeout(function () {
        if (!paused && !document.hidden) go(i + 1, 1);
        schedule();
      }, AUTO_MS);
    }
    /* a person stepped through it: announce changes to screen readers, restart the 5 seconds */
    function step(n, dir) {
      if (list) list.setAttribute('aria-live', 'polite');
      go(n, dir);
      schedule();
    }
    if (list && !still()) list.setAttribute('aria-live', 'off');

    var p = bar.querySelector('[data-prev]'), nx = bar.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { step(i - 1, -1); });
    if (nx) nx.addEventListener('click', function () { step(i + 1, 1); });

    /* hold still for a mouse that is over the bar (touch taps do not count) and for keyboard focus */
    bar.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') paused = true; });
    bar.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') paused = false; });
    bar.addEventListener('focusin', function (e) {
      var kb = true;
      try { kb = e.target.matches(':focus-visible'); } catch (err) {}
      if (kb) paused = true;
    });
    bar.addEventListener('focusout', function () { paused = false; });

    /* swipe: left moves to the next offer, right to the previous one */
    var sx = 0, sy = 0, swiping = false;
    bar.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { swiping = false; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiping = true;
    }, { passive: true });
    bar.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      if (dx < 0) step(i + 1, 1); else step(i - 1, -1);
    }, { passive: true });
    bar.addEventListener('touchcancel', function () { swiping = false; }, { passive: true });

    /* the reduced-motion setting can change while the page is open */
    function motionChanged() {
      settle();
      if (list && !still() && list.getAttribute('aria-live') !== 'polite') list.setAttribute('aria-live', 'off');
      schedule();
    }
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', motionChanged);
      else if (mq.addListener) mq.addListener(motionChanged);
    }
    schedule();
  });
})();

/* ---------- 10-05: product rows move on by themselves and can be dragged with a mouse (phones already swipe) ----------
   Any scroll track marked data-dn-auto: steps one card every 4 s while on screen, back to the start after the last card.
   Stops while the pointer is over it, while it has focus, and for 8 s after any touch, drag or arrow click.
   Never moves for people who ask for reduced motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function card(track) {
    var c = track.firstElementChild;
    var g = parseFloat(getComputedStyle(track).columnGap) || 16;
    return c ? c.getBoundingClientRect().width + g : 280;
  }
  function setup(track) {
    if (!track || track.__dnAuto) return;
    track.__dnAuto = true;
    var hover = false, focus = false, seen = false, quietUntil = 0;
    function quiet() { quietUntil = Date.now() + 8000; }
    track.addEventListener('mouseenter', function () { hover = true; });
    track.addEventListener('mouseleave', function () { hover = false; });
    track.addEventListener('focusin', function () { focus = true; });
    track.addEventListener('focusout', function () { focus = false; });
    track.addEventListener('touchstart', quiet, { passive: true });
    track.addEventListener('wheel', quiet, { passive: true });
    var scope = track.closest('section') || track.parentNode;
    if (scope) scope.addEventListener('click', function (e) { if (e.target.closest('button')) quiet(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }, { threshold: 0.5 }).observe(track);
    } else { seen = true; }

    /* mouse drag: flick through like a phone; a drag never counts as a click on the card under it */
    var down = false, moved = false, startX = 0, startL = 0, lastX = 0, lastT = 0, v = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = lastX = e.clientX; startL = track.scrollLeft; lastT = performance.now(); v = 0; quiet();
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) { moved = true; track.style.scrollSnapType = 'none'; track.style.cursor = 'grabbing'; }
      if (!moved) return;
      var t = performance.now(); v = (e.clientX - lastX) / Math.max(1, t - lastT); lastX = e.clientX; lastT = t;
      track.scrollLeft = startL - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      if (!moved) return;
      track.style.cursor = '';
      var target = track.scrollLeft - v * 260, w = card(track);
      target = Math.round(target / w) * w;
      track.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function () { track.style.scrollSnapType = ''; }, 450);
      quiet();
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* 10-08: on a phone (no hover) a row never moves by itself: it swiped fine already, and a row stepping while the page is scrolled looked like a glitch (his bags note) */
    if (reduce || (window.matchMedia && window.matchMedia('(hover: none)').matches)) return;
    setInterval(function () {
      if (!seen || hover || focus || down || Date.now() < quietUntil || document.hidden) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max < 8) return;
      if (track.scrollLeft >= max - 8) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: card(track), behavior: 'smooth' });
    }, 4000);
  }
  window.dnAuto = setup;
  function all() { document.querySelectorAll('[data-dn-auto]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

/* 10-07 (his mobile note 15): on a phone a product card has no hover, so a left swipe on the photo slides in the "being worn" photo and a right swipe slides it back,
   with two small dots. The worn photo is only fetched once the card is mostly on screen (phones were kept off it for speed, 10-05), and a card with no worn photo
   is left alone. A tap still opens the product. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: none)').matches) return;
  var MAP = [
    { card: '.dnc-card', box: '.dnc-img', worn: 'img.b' },
    { card: '.dnh-card--product', box: '.dnh-card__img', worn: 'img.dnh-worn' }
  ];
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var c = e.target;
        if (e.isIntersecting) {
          if (c._dnT) return;
          c._dnT = setTimeout(function () { load(c); }, 350);
        } else if (c._dnT) { clearTimeout(c._dnT); c._dnT = 0; }
      });
    }, { threshold: 0.6 });
  }
  function load(card) {
    var img = card._dnW;
    if (!img || card._dnLoaded) return;
    var src = img.getAttribute('data-worn');
    if (!src) return;
    card._dnLoaded = true;
    /* 700 wide is the desktop size; a phone card is about 190 css px wide, so 450 is plenty */
    src = src.replace(/width=700/, 'width=450');
    img.addEventListener('load', function () { card.classList.add('has-worn'); if (io) io.unobserve(card); }, { once: true });
    /* the phone-only <source> in the card markup points at a 1px blank, so it has to go before the real address can show */
    var pic = img.parentNode;
    if (pic && pic.tagName === 'PICTURE') { var so = pic.querySelector('source'); if (so) so.parentNode.removeChild(so); }
    img.removeAttribute('srcset');
    img.src = src;
  }
  function setup(cfg, card) {
    if (card._dnSwipe) return;
    var box = card.querySelector(cfg.box), worn = box && box.querySelector(cfg.worn);
    if (!worn || !worn.getAttribute('data-worn')) return;
    card._dnSwipe = true; card._dnW = worn;
    var dots = document.createElement('i');
    dots.className = 'dn-swp'; dots.setAttribute('aria-hidden', 'true');
    dots.innerHTML = '<b class="on"></b><b></b>';
    box.appendChild(dots);
    if (io) io.observe(card);
    var sx = 0, sy = 0, on = false, swiped = false;
    box.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { on = false; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; on = true; swiped = false;
      if (!card._dnLoaded) load(card);
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (!on) return;
      on = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 28 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      if (!card.classList.contains('has-worn')) return;
      swiped = true;
      var showWorn = dx < 0;
      card.classList.toggle('is-worn', showWorn);
      var d = dots.children; d[0].classList.toggle('on', !showWorn); d[1].classList.toggle('on', showWorn);
      setTimeout(function () { swiped = false; }, 450);
    }, { passive: true });
    box.addEventListener('touchcancel', function () { on = false; }, { passive: true });
    box.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); e.stopPropagation(); } }, true);
  }
  function all(root) {
    MAP.forEach(function (cfg) { (root || document).querySelectorAll(cfg.card).forEach(function (c) { setup(cfg, c); }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function () { all(); });
  /* cards added later (quick filters, load more) */
  if ('MutationObserver' in window) {
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(all, 200); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
})();
